<template>
  <div class="personnelinfo">
    <!-- 返回导航栏 -->

    <div class="info-box" >
      <div class="usernames">{{personInfo.name}}</div>
      <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
    </div>

    <div class="wrapper-box" >
      <div v-if="!(personInfo.type == 3 ||  personInfo.id == 'legalRepresentative')">
         <listItem
          :label="'职务'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.office || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="!(personInfo.type == 3 ||  personInfo.id == 'legalRepresentative' || personInfo.type == 4 || personInfo.isSeriousPerson == 1)">
        <listItem
          :label="'部门'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.organization || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="!(personInfo.type == 3 ||  personInfo.id == 'legalRepresentative' || personInfo.type == 4 || personInfo.isSeriousPerson == 1) ">
        <listItem
          :label="'性别'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.sexStr || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="!(personInfo.type == 3 ||  personInfo.id == 'legalRepresentative' || personInfo.type == 4 || personInfo.isSeriousPerson == 1) ">
        <listItem
          :label="'民族'"
          :showRight="false"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
        >{{personInfo.nation || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="personInfo.type == 3">
        <listItem
          :label="'出资企业名称'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.investedEnterpriseName || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="personInfo.type == 3">
        <listItem
          :label="'出资额（万元/人民币）'"
          :textAlign="'right'"
          :labelWidth="164"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.contributionAmount ? personInfo.contributionAmount + '万元' : '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div v-if="!(personInfo.type == 4 ||  personInfo.isSeriousPerson == 1)">
        <listItem
          :label="'证件类型'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >身份证</listItem>
        <rline></rline>
      </div>
      <div v-if="!(personInfo.type == 4 ||  personInfo.isSeriousPerson == 1)">
        <listItem
          :label="'证件号码'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.idcard || '暂无信息'}}</listItem>
        <rline></rline>
      </div>
      <div>
        <listItem
          :label="'联系电话'"
          :textAlign="'right'"
          :labelWidth="114"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{personInfo.phone || '暂无信息'}}</listItem>
      </div>
    </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                personInfo: {},
                isEmpty: true
            };
        },

        computed: {},

        watch: {},

        methods: {
        },

        mounted () {
            if (localStorage.travelMemberList) {
                let travelMemberList = JSON.parse(localStorage.travelMemberList)
                travelMemberList.map((items, index) => {
                    if (items.id === this.$route.query.id) {
                        this.personInfo = items
                        this.isEmpty = false
                    }
                })
            }
        },
        created () {}
    };
</script>
<style scoped lang="less">
.personnelinfo {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  padding-top: 16px;
  .info-box {
    width: 351px;
    box-sizing: border-box;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 68px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 auto;
    margin-bottom: 16px;

    .usernames {
      font-size: 20px;
      font-family: PingFang SC,Arial,sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: 700;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }

    .headimg {
      width: 36px;
      height: 36px;
    }
  }
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 16px 12px 0 12px;
  }
}
</style>
